var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UtteranceControl',_vm._g(_vm._b({attrs:{"disabled-enter":_vm.disabled,"customEndter":true},on:{"disabledEnter":_vm.handelDisabledEnter,"enter":_vm.handelEnter}},'UtteranceControl',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }